<template>
  <div>
    <b-input-group>
      <b-input-group-prepend is-text>
        <i class="fa fa-search"></i>
      </b-input-group-prepend>
      <b-form-input placeholder="Buscar ..." :value="terms" @input="sendInput" @keyup.enter="$emit('enter')"/>
      <b-input-group-append is-text v-if="ventana == 0">
        <b-form-checkbox
          v-model="dniCuitCuil"
          @change="checkboxValueChange"
        >
          DNI/CUIT/CUIL
        </b-form-checkbox>
    </b-input-group-append>
    </b-input-group>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dniCuitCuil: false
    }
  },
  model: {
    prop: 'terms',
    event: 'input'
  },
  props: {
    terms: String,
    ventana: Number,
    checkboxPadre: {
      type: Boolean,
      default: false
    },
  },
  methods: {
    sendInput(val) {
      this.$emit('input', val)
    },
    checkboxValueChange(valCheck){
      // //console.log(valCheck)
      this.$emit('checkChanged', valCheck)
    }
  },
  watch: {
    checkboxPadre: {
      deep: true,
      handler: function(val){
        if(val){
          this.dniCuitCuil = true
        }else{
          this.dniCuitCuil = false
        }
      }
    }
  }
}
</script>
